var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-tooltip',{attrs:{"label":_vm.picksTooltipLabel,"type":_vm.picksTooltipType,"position":"is-right"}},[_c('button',{class:{
      'icon-picks': true,
      'icon-picks_disabled': !_vm.receiver?.id,
    },attrs:{"type":"button"},on:{"click":function($event){return _vm.sendTip()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }